import FloatingLabelTextMask from './FloatingLabelTextMask';

export default FloatingLabelTextMask;



// WEBPACK FOOTER //
// ./src/components/common/FloatingLabelTextMask/index.js